module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card-plain': _vm.isPlain
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_vm._t("header", [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.subTitle))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "card-content table-responsive"
  }, [_c('table', {
    staticClass: "table",
    class: _vm.tableClass
  }, [_c('thead', _vm._l((_vm.columns), function(column) {
    return _c('th', [_vm._v(_vm._s(column))])
  })), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item) {
    return _c('tr', _vm._l((_vm.columns), function(column) {
      return (_vm.hasValue(item, column)) ? _c('td', [_vm._v(_vm._s(_vm.itemValue(item, column)))]) : _vm._e()
    }))
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df365df8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/MaterialTable.vue
// module id = 175
// module chunks = 2